var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestionAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.147,
    height: 35.147,
    viewBox: "0 0 35.147 35.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f7072;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.574,35.147A17.574,17.574,0,1,0,0,17.574,17.574,17.574,0,0,0,17.574,35.147Zm0-30.754c4.374,0,8.787,2.5,8.787,8.1,0,3.258-1.615,5.8-4.8,7.552-.923.507-1.793,1.511-1.793,1.92a2.2,2.2,0,1,1-4.393,0c0-2.788,2.557-4.938,4.068-5.769,2.221-1.226,2.522-2.561,2.522-3.7,0-3.227-2.752-3.708-4.393-3.708a4.231,4.231,0,0,0-4.393,4.44,2.2,2.2,0,0,1-4.393,0A8.627,8.627,0,0,1,17.574,4.393Zm0,26.457a2.263,2.263,0,1,1,2.263-2.263A2.262,2.262,0,0,1,17.574,30.85Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionAlt);
export default __webpack_public_path__ + "static/media/icon_question_alt.45f8e323.svg";
export { ForwardRef as ReactComponent };